export const reprintPin = {
    hideDeliveryAddress: true,
};
